import { Opportunity } from '../../models/OpportunityModels';
import { ENV } from '../../envUtils';

/**
 * Endpoint path builders for opportunity CRUD, lifecycle transitions (submit, cancel, qualify, decline), and priority adjustments.
 *
 * Each property is a function returning a URL path string from ENV combined with the opportunity's aim value and an action segment; none of them make HTTP requests directly.
 */
export const opportunityEndpoints = {
  opportunities: `${ENV}/opportunities`,
  opportunityDetails: (aimOpportunity: Pick<Opportunity, 'aimOpportunity'>) =>
    `${ENV}/opportunity/${aimOpportunity}`,
  newOpportunity: `${ENV}/opportunity/new`,
  submitOpportunity: (aimOpportunity: Pick<Opportunity, 'aimOpportunity'>) =>
    `${ENV}/opportunity/${aimOpportunity}/submit`,
  cancelOpportunity: (aimOpportunity: number) => `${ENV}/opportunity/${aimOpportunity}/cancel`,
  qualifyOpportunityLand: (aimOpportunity: Pick<Opportunity, 'aimOpportunity'>) =>
    `${ENV}/opportunity/${aimOpportunity}/qualify/land`,
  qualifyOpportunityCeo: (aimOpportunity: Pick<Opportunity, 'aimOpportunity'>) =>
    `${ENV}/opportunity/${aimOpportunity}/qualify/ceo`,
  qualifyOpportunityOperations: (aimOpportunity: Pick<Opportunity, 'aimOpportunity'>) =>
    `${ENV}/opportunity/${aimOpportunity}/qualify/operations`,
  declineOpportunityLand: (aimOpportunity: Pick<Opportunity, 'aimOpportunity'>) =>
    `${ENV}/opportunity/${aimOpportunity}/decline/land`,
  declineOpportunityCeo: (aimOpportunity: Pick<Opportunity, 'aimOpportunity'>) =>
    `${ENV}/opportunity/${aimOpportunity}/decline/ceo`,
  declineOpportunityOperations: (aimOpportunity: Pick<Opportunity, 'aimOpportunity'>) =>
    `${ENV}/opportunity/${aimOpportunity}/decline/operations`,
  getLandQualification: (aimOpportunity: Pick<Opportunity, 'aimOpportunity'>) =>
    `${ENV}/opportunity/${aimOpportunity}/qualify/land`,
  getCeoQualification: (aimOpportunity: Pick<Opportunity, 'aimOpportunity'>) =>
    `${ENV}/opportunity/${aimOpportunity}/qualify/ceo`,
  getOperationsQualification: (aimOpportunity: Pick<Opportunity, 'aimOpportunity'>) =>
    `${ENV}/opportunity/${aimOpportunity}/qualify/operations`,
  updateOpportunity: (aimOpportunity: number) => `${ENV}/opportunity/${aimOpportunity}`,
  raiseOpportunityPriority: (aimOpportunity: Pick<Opportunity, 'aimOpportunity'>) =>
    `${ENV}/opportunity/${aimOpportunity}/priority/raise`,
  lowerOpportunityPriority: (aimOpportunity: Pick<Opportunity, 'aimOpportunity'>) =>
    `${ENV}/opportunity/${aimOpportunity}/priority/lower`,
  markOpportunityMapped: (aimOpportunity: Pick<Opportunity, 'aimOpportunity'>) =>
      `${ENV}/opportunity/${aimOpportunity}/mapped`
};
